{
  "UnifiedNavigation": "Experience Cloud 内を移動",
  "adobeExperienceCloudNoOrgsSelect": "別の組織アカウントを選択",
  "help": "ヘルプ",
  "ok": "OK",
  "profile": "プロファイル",
  "searchButton": "検索",
  "sidenavMenuCloseTooltip": "メニューを閉じる",
  "sidenavMenuLockTooltip": "クリックしてメニューをロック",
  "solutionSwitcher": "別のソリューションに切り替え",
  "themeCoachMark": "ライトテーマ",
  "themeCoachMarkMessage": "Experience Cloud ヘッダーでライトテーマとダークテーマの両方がサポートされるようになりました。アバターをクリックし、好みのテーマに切り替えます。",
  "toggleSideNav": "サイドナビゲーションメニューを切り替え"
}
